module.exports = __webpack_public_path__ + "static/img/img3.f863cd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img3.png
// module id = Z4mK
// module chunks = 1